import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import styles from './star-rating.module.less';

var Star = function Star(_ref) {
  var _classNames, _classNames2;

  var className = _ref.className,
      error = _ref.error,
      nerdwallet = _ref.nerdwallet,
      otherProps = _objectWithoutProperties(_ref, ["className", "error", "nerdwallet"]);

  var firstHalfStarClasses = classNames(styles['star--first-half'], (_classNames = {}, _defineProperty(_classNames, styles.error, error), _defineProperty(_classNames, styles.green, nerdwallet), _defineProperty(_classNames, styles.yellow, !nerdwallet), _classNames));
  var secondHalfStarClasses = classNames(styles['star--second-half'], (_classNames2 = {}, _defineProperty(_classNames2, styles.error, error), _defineProperty(_classNames2, styles.green, nerdwallet), _defineProperty(_classNames2, styles.yellow, !nerdwallet), _classNames2));
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    className: classNames(className, styles.star)
  }, otherProps), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "outline_selected"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00aacc",
    result: "base"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    result: "bigger",
    "in": "SourceGraphic",
    operator: "dilate",
    radius: "1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "mask",
    "in": "bigger",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "drop",
    "in": "base",
    in2: "mask",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    "in": "drop",
    stdDeviation: "1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "blur",
    mode: "normal"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd",
    className: styles['inner-group']
  }, /*#__PURE__*/React.createElement("polygon", {
    className: firstHalfStarClasses,
    transform: "translate(3.501500, 6.650000) translate(-3.501500, -6.650000) ",
    points: "6.996 0 5.03 4.63725674 0 5.0730929 3.813 8.38284867 2.674 13.3000002 7.001 10.6979784 7.003 10.6999776"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: secondHalfStarClasses,
    transform: "translate(10.470000, 6.650000) scale(-1, 1) translate(-10.490000, -6.650000)",
    points: "13.9830028 -1.0658141e-14 12.017845 4.63725674 6.98999977 5.0730929 10.8013663 8.38284867 9.66285426 13.3000002 13.9880006 10.6979784 13.9899998 10.6999776"
  })));
};

Star.displayName = 'Star';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Star.propTypes = {
    className: PropTypes.string,
    nerdwallet: PropTypes.bool,
    error: PropTypes.bool
  };
}

Star.defaultProps = {
  className: null,
  nerdwallet: false,
  error: false
};
/** produces a set of stars, optionally as inputs */

var Stars = function Stars(_ref2) {
  var id = _ref2.id,
      error = _ref2.error,
      maxRating = _ref2.maxRating,
      nerdwallet = _ref2.nerdwallet,
      onChange = _ref2.onChange,
      rating = _ref2.rating,
      otherProps = _objectWithoutProperties(_ref2, ["id", "error", "maxRating", "nerdwallet", "onChange", "rating"]);

  var stars = [];
  var isInput = !!id;

  for (var index = 0; index < maxRating; index += 1) {
    var _classNames3;

    // Logic for determining if any given star should be highlighted.
    var value = index + 1;
    var isInRange = value <= rating;
    var checked = Math.ceil(rating) === value;
    var isHalfHighlighted = checked && value > rating;
    var starId = "".concat(id, "__").concat(value);
    var starClass = styles.empty;

    if (isInRange) {
      starClass = styles.full;
    } else if (isHalfHighlighted) {
      starClass = styles.half;
    }

    var classes = classNames(starClass, (_classNames3 = {}, _defineProperty(_classNames3, styles['is-clickable'], isInput), _defineProperty(_classNames3, styles['is-selected'], isInRange), _defineProperty(_classNames3, styles['star-field'], isInput), _classNames3));
    var radio = isInput && /*#__PURE__*/React.createElement("input", _extends({
      className: styles.radio,
      type: "radio",
      checked: checked,
      id: starId,
      name: id,
      onChange: onChange,
      onClick: onChange,
      value: value
    }, otherProps));
    var star = isInput ?
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control -- directive added automatically by Shepherd migration
    React.createElement("label", {
      htmlFor: starId,
      className: styles.label
    }, /*#__PURE__*/React.createElement(Star, {
      role: "presentation",
      "aria-label": "".concat(value, " out of ").concat(maxRating),
      nerdwallet: nerdwallet,
      error: error
    })) : /*#__PURE__*/React.createElement(Star, {
      nerdwallet: nerdwallet,
      error: error
    });
    stars.push( /*#__PURE__*/React.createElement("span", {
      className: classNames(classes),
      key: index
    }, radio, star));
  }

  if (isInput) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, stars);
  }

  return /*#__PURE__*/React.createElement("div", otherProps, stars);
};

Stars.displayName = 'Stars';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes = require('prop-types');

  Stars.propTypes = {
    id: _PropTypes.string,
    error: _PropTypes.bool,
    maxRating: _PropTypes.number,
    nerdwallet: _PropTypes.bool,
    onChange: _PropTypes.func,
    rating: _PropTypes.number
  };
}

Stars.defaultProps = {
  error: false,
  id: null,
  onChange: function onChange() {},
  maxRating: null,
  nerdwallet: false,
  rating: null
};
export default Stars;